import 'lazysizes';
import 'alpinejs';

import '@components/Footer/script';
import '@components/ItineraryBuilderMap/script';
import '@components/MobileNavigation/script';
import '@components/Navigation/script';
import '@components/Subscribe/script';
import '@components/ProductMap/script';
import '@components/RegionMap/script';

import '@/aos';
import '@/search';
import '@/stickynav';
import '@/toggle';
import initSwipers from '@/swiper';
initSwipers();

// Handle anchor scrolling on campaign pages
if (document.body.classList.contains('campaign')) {
    const scrollToAnchor = (hash) => {
        if (!hash) return;
        const el = document.querySelector(hash);
        if (el) {
            const headerOffset = 100;
            const elementPosition = el.offsetTop;
            const offsetPosition = elementPosition - headerOffset;
            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
    };

    // Prevent default anchor scroll on initial page load
    if (window.location.hash) {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
    }

    // Handle initial page load with hash
    window.addEventListener('load', () => {
        if (window.location.hash) {
            // Initial scroll after a delay
            setTimeout(() => scrollToAnchor(window.location.hash), 100);
            // Recalculate after images have had time to load/fail
            setTimeout(() => scrollToAnchor(window.location.hash), 500);
            // Final correction for elements at the bottom of the page
            setTimeout(() => scrollToAnchor(window.location.hash), 1000);
        }
    });

    // Handle clicks on anchor links within the page
    window.addEventListener('hashchange', (e) => {
        e.preventDefault();
        setTimeout(() => scrollToAnchor(window.location.hash), 50);
    });
}
